export abstract class Entity {
    protected ensureDate(value: Date, defaultValue?: Date): Date {
        if (defaultValue === undefined) {
            defaultValue = null;
        }

        if (value) {
            const type: string = typeof value;
            if (type == 'string' || type == 'String') {
                return new Date(Date.parse(<any> value));
            } else if (type == 'object' || type == 'Object') {
                return value;
            }
        }

        return defaultValue;
    }
}
